<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import AppFooter from './AppFooter.vue';
import AppSidebar from './AppSidebar.vue';
import AppTopbar from './AppTopbar.vue';

const { t, locale } = useI18n();
const { layoutConfig, layoutState, hideMobileMenu } = useLayout();

const user = ref(JSON.parse(localStorage.getItem('user')));
const workspaces = ref(JSON.parse(localStorage.getItem('workspaces')) || []);
const freeBannerDismissed = ref(false);
const showFreeBanner = computed(() =>
  workspaces.value.length === 1 &&
  user.value?.plan?.name === 'open' &&
  !freeBannerDismissed.value
);

const pricingURLData = import.meta.env.VITE_PRICING_URL.split(',');

const pricingURL = computed(() => {
  switch (locale.value) {
    case 'fr': return pricingURLData[0];
    case 'en': return pricingURLData[1];
    case 'de': return pricingURLData[2];
    case 'es': return pricingURLData[3];
    case 'it': return pricingURLData[4];
    case 'pt': return pricingURLData[5];
    default: return 'https://www.nemorius.com';
  }
});

const containerClass = computed(() => {
    return {
        'layout-overlay': layoutConfig.menuMode === 'overlay',
        'layout-static': layoutConfig.menuMode === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive,
        'layout-mobile-active': layoutState.mobileMenuActive,
        'layout-static-inactive': layoutState.staticMenuInactive,
        'layout-sidebar-collapsed': layoutConfig.sidebarCollapsed,
        'has-banner': showFreeBanner.value
    };
});
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <div v-if="showFreeBanner" class="app-banner relative flex items-center justify-center px-12"
            style="background-color: var(--p-primary-color); color: var(--p-primary-contrast-color);">
            <p class="text-base m-0 leading-none">
                <span v-html="t('banner.free')"></span>
                <a :href="pricingURL" target="_blank" rel="noopener" class="!underline ml-1">{{ t('banner.offers') }}</a>
            </p>
            <button type="button"
                class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center w-7 h-7 rounded hover:bg-black/10 cursor-pointer"
                @click="freeBannerDismissed = true" :aria-label="t('common.labels.close')">
                <i class="pi pi-times text-sm"></i>
            </button>
        </div>
        <AppTopbar />
        <AppSidebar />
        <div class="layout-main-container">
            <div class="layout-main">
                <router-view />
            </div>
            <AppFooter />
        </div>
        <div class="layout-mask animate-fadein" @click="hideMobileMenu"></div>
    </div>
    <Toast />
</template>
